// bd-deepcontext-b4zw — the two full-page states that stand in for the job list:
// the auth-loading spinner and the non-staff refusal (bd-deepcontext-dnjks).
// Extracted from ScheduledJobs.tsx unchanged.
import { ArrowPathIcon, XCircleIcon } from "@heroicons/react/24/outline";
import React from "react";

export const JobsAuthLoading: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen bg-canvas">
    <div className="text-center">
      <ArrowPathIcon className="h-12 w-12 text-ink-muted animate-spin mx-auto mb-4" />
      <p className="text-ink-muted">Loading...</p>
    </div>
  </div>
);

export const JobsAccessDenied: React.FC<{ role?: string }> = ({ role }) => (
  <div className="flex items-center justify-center min-h-96 bg-canvas">
    <div className="text-center">
      <XCircleIcon className="h-16 w-16 text-risk mx-auto mb-4" />
      <h2 className="text-2xl font-bold text-ink mb-2">Access Denied</h2>
      <p className="text-ink-muted">You do not have access to scheduled jobs.</p>
      <p className="text-sm text-ink-muted mt-2">Your role: {role || "unknown"}</p>
    </div>
  </div>
);
